import React from 'react';
import { useLanguageControls } from '../../../../hooks/useLanguageControls';

const StatsScore = React.forwardRef(function StatsScore({ score, maxScore }, ref) {
  const { isArabic } = useLanguageControls();

  const formatScore = () => {
    if (!maxScore) return score;

    return isArabic ? `${maxScore}/${score}` : `${score}/${maxScore}`;
  };

  return (
    <div className={'stats__score-data'}>
      <div className={'stats__score-wrapper'}>
        <p className={'stats__score'}>{formatScore()}</p>
      </div>
    </div>
  );
});
export default StatsScore;
StatsScore.propTypes = {};
